<script>
import { list } from '@/api/tabeladesconto'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ tabela_nome: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="tabela_nome"
    width="1000"
    component="app-tabeladesconto-grid"
    label="Tabela Desconto"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
